import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCheckCircleFilled = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M12 1.5C14.0265 1.5 15.8686 1.99118 17.4242 2.87125C18.9797 3.75132 20.2487 5.02027 21.1288 6.57583C22.0088 8.13139 22.5 9.97354 22.5 12C22.5 14.0265 22.0088 15.8686 21.1288 17.4242C20.2487 18.9797 18.9797 20.2487 17.4242 21.1288C15.8686 22.0088 14.0265 22.5 12 22.5C9.97354 22.5 8.13139 22.0088 6.57583 21.1288C5.02027 20.2487 3.75132 18.9797 2.87125 17.4242C1.99118 15.8686 1.5 14.0265 1.5 12C1.5 9.97354 1.99118 8.13139 2.87125 6.57583C3.75132 5.02027 5.02027 3.75132 6.57583 2.87125C8.13139 1.99118 9.97354 1.5 12 1.5Z",
		fill: "currentColor"
	}), /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M17.5379 8.33709C17.904 8.7032 17.904 9.2968 17.5379 9.66291L11.5379 15.6629C11.1718 16.029 10.5782 16.029 10.2121 15.6629L6.83709 12.2879C6.47097 11.9218 6.47097 11.3282 6.83709 10.9621C7.2032 10.596 7.7968 10.596 8.16291 10.9621L10.875 13.6742L16.2121 8.33709C16.5782 7.97097 17.1718 7.97097 17.5379 8.33709Z",
		fill: "white"
	})]
});
const ForwardRef = forwardRef(SvgCheckCircleFilled);
export { ForwardRef as ReactComponent };
